import * as dateFns from 'date-fns';
import { enUS, nb } from 'date-fns/locale';
import i18n from '../../i18n';
import {
    MESSAGES_HEADINGS
} from '../../constants/pushMessages';

export const prepareRowData = (currentMsg) => {
    const locale = (i18n.language === 'no') ? nb : enUS;
    if (currentMsg) {
        return {
            [MESSAGES_HEADINGS.MESSAGE_ID]: currentMsg.id || '-',
            ...(!currentMsg.admin && {
                [MESSAGES_HEADINGS.RECEIVER_ID]: currentMsg.userId || currentMsg.topic || '-',
            }),
            [MESSAGES_HEADINGS.DATE]: currentMsg.timestamp._seconds ?
                dateFns.format(new Date(currentMsg.timestamp._seconds * 1000), 'd MMMM yyyy HH:mm', {locale}) :
                '-',
            [MESSAGES_HEADINGS.TITLE]: currentMsg.title || '-',
            [MESSAGES_HEADINGS.MESSAGE]: currentMsg.body || '-',
            ...(currentMsg.admin && {
                [MESSAGES_HEADINGS.SIGNATURE]: currentMsg.admin.signatureType || '-',
            }),
            ...(currentMsg.userIds && {
                [MESSAGES_HEADINGS.CANDIDATE]: currentMsg.userIds.length || '-',
            }),
        }
    } 
};

export const prepareRowDataForSorting = (currentMsg) => {
    if (currentMsg) {
        return {
            [MESSAGES_HEADINGS.MESSAGE_ID]: currentMsg.id || '-',
            ...(!currentMsg.admin && {
                [MESSAGES_HEADINGS.RECEIVER_ID]: currentMsg.userId || currentMsg.topic || '-',
            }),
            [MESSAGES_HEADINGS.DATE]: currentMsg.timestamp?._seconds || 0,
            [MESSAGES_HEADINGS.TITLE]: currentMsg.title || '-',
            [MESSAGES_HEADINGS.MESSAGE]: currentMsg.body || '-',
            ...(currentMsg.admin && {
                [MESSAGES_HEADINGS.SIGNATURE]: currentMsg.admin.signatureType || '-',
            }),
            ...(currentMsg.userIds && {
                [MESSAGES_HEADINGS.CANDIDATE]: currentMsg.userIds.length || '-',
            }),
        }
    }
};

function sortDates(a, b) {
  const dateA = a ? a * 1000 : 0;
  const dateB = b ? b * 1000 : 0;

  if (dateA === dateB) return 0;
  return dateA < dateB ? -1 : 1;
}

export const sortTableData = (tableData, sortKey, clicks) => {
    let newTableData = [...tableData];

    if (tableData.length > 1) {
        let value = 0;
        const sortOrder = clicks % 2;

        if (sortKey === MESSAGES_HEADINGS.DATE) {
            newTableData = newTableData.sort(
                (a, b) => {
                    const dateA = a.prepared?.[sortKey];
                    const dateB = b.prepared?.[sortKey];

                    if (dateA === 0 || dateA === "-") {
                        return 1;
                    }
                    if (dateB === 0 || dateB === "-") {
                        return -1;
                    }

                    const result = sortDates(dateA, dateB);
                    return sortOrder === 1 ? result : -result;
                },
            );
        } else if (typeof tableData[0].sortable?.[sortKey] === 'string') {
            newTableData = newTableData.sort(
                (a, b) => {
                    if (a.sortable[sortKey] === "-") {
                        return 1;
                    }
                    if (b.sortable[sortKey] === "-") {
                        return -1;
                    }
                    if (a.sortable[sortKey] > b.sortable[sortKey]) {
                        value = sortOrder === 1 ? 1 : -1;
                    }
                    if (a.sortable[sortKey] < b.sortable[sortKey]) {
                        value = sortOrder === 1 ? -1 : 1;
                    }
                    return value;
                },
            );
        } else if (typeof tableData[0].sortable?.[sortKey] === 'number') {
            newTableData = newTableData.sort(
                (a, b) => {
                    if (a.sortable[sortKey] === 0) {
                        return 1;
                    }
                    if (b.sortable[sortKey] === 0) {
                        return -1;
                    }
                    if (+a.sortable[sortKey] > +b.sortable[sortKey]) {
                        value = sortOrder === 1 ? 1 : -1;
                    }
                    if (+a.sortable[sortKey] < +b.sortable[sortKey]) {
                        value = sortOrder === 1 ? -1 : 1;
                    }
                    return value;
                },
            );
        }
    }
    return [...newTableData];
};